export default class UnableToProcessPaymentError extends Error {
	constructor(phoneNumber?: number) {
		let message = "Unable to process payment. Please contact the clinic";
		if (phoneNumber) message += ` on ${phoneNumber}`;
		super(message + ".");
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
